import React from "react";
import { Tbody, Tr, Td } from "@chakra-ui/react";

const CustomTBody = ({ rows }) => {
  return (
    <Tbody>
      {rows.map((row, index) => (
        <Tr
          _hover={{
            outline: "2px #3498DB solid",
          }}
          key={index}
        >
          {row.map((cell, index) => {
            return (
              <Td key={index} {...cell.tdStyle}>
                {cell.item}
              </Td>
            );
          })}
        </Tr>
      ))}
    </Tbody>
  );
};

export default CustomTBody;
